//import { Api } from '@apis/client';

//需要特殊处理的接口异常码
const interfaceErrorMessages = {
  //示例；
  // [Api.GetDevicesByUserUid]: {
  //   40000: '设备信息异常',
  //   41000: '学生证设备不存在',
  // }
};

export const extraHandlerCode = {
  /**
   * 离线状态码 50015
   */
  DEVICE_OFFLINE: 50015,
  /**
   * 锁定状态码 50018
   */
  DEVICE_LOCKED: 50018,
  /**
   * 禁用状态码 50019
   */
  DEVICE_FORBID: 50019,
}

//获取接口错误信息
export function get(action, result) {
  const messages = interfaceErrorMessages[action];
  return messages ? messages[result.statusCode] : result.message;
}
